/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Legaroo_DescriptionInputs */

const en_service_legaroo_description = /** @type {(inputs: Service_Legaroo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access to legal resources and support services — an added layer of protection for navigating unexpected situations while travelling abroad.`)
};

const fr_service_legaroo_description = /** @type {(inputs: Service_Legaroo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès à des ressources juridiques et des services de soutien — une couche de protection supplémentaire pour naviguer dans les situations imprévues à l'étranger.`)
};

/**
* | output |
* | --- |
* | "Access to legal resources and support services — an added layer of protection for navigating unexpected situations while travelling abroad." |
*
* @param {Service_Legaroo_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_legaroo_description = /** @type {((inputs?: Service_Legaroo_DescriptionInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Legaroo_DescriptionInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_legaroo_description(inputs)
	return fr_service_legaroo_description(inputs)
});